import { downloadPdf } from './downloadPdf'
import { getProjectById } from './getProjectById'
import { compsImageUrls } from './compsImageUrls'
import { getCompsOffices } from './compsRegions'
import { saveCompsProject } from './saveCompsProject'
import { getRecentProjects } from './getRecentProjects'
import { updateCompsProject } from './updateCompsProject'
import { searchProjects } from './searchProjects'
import { getAllProjects } from './getAllProjects'
import { deleteProject } from './deleteProject'
import { loadRegions } from './loadRegions'
import { setProjectAsFavorite } from './setProjectAsFavorite'
import { getCities } from './getCities'
import { getUsers } from './getUsers'
import { getPropertyInfo } from './getPropertyInfo'
import { getListInfo } from './getListInfo'
import { fetchImagesPropertyList } from './fetchImagesPropertyList'
import { refreshListInfo } from './refreshListInfo'
import { getMapProjects } from './getMapProjects'

export default [
  downloadPdf,
  compsImageUrls,
  getProjectById,
  getCompsOffices,
  saveCompsProject,
  getRecentProjects,
  updateCompsProject,
  searchProjects,
  getAllProjects,
  deleteProject,
  loadRegions,
  setProjectAsFavorite,
  getCities,
  getUsers,
  getPropertyInfo,
  getListInfo,
  fetchImagesPropertyList,
  refreshListInfo,
  getMapProjects
]
